import { useQueries } from '@tanstack/react-query'
import { getExperienceDetail } from 'tripPlanner/api'
import * as ExperienceDetailKeys from 'tripPlanner/hooks/reactQueryKeys/experienceDetail'
import { nonNullable } from 'lib/array/arrayUtils'

const EXPERIENCE_DETAIL_STALE_TIME = 10 * 60 * 1000

interface UseExperienceDetailsOptions {
  offerIds: Array<string>
  currencyCode: string
  enabled?: boolean
}

// Multi-offer variant of useExperienceDetail. Used to back saved experiences that
// are not present in the live search results, so the drawer never drops a saved row.
export default function useExperienceDetails({
  offerIds,
  currencyCode,
  enabled = true,
}: UseExperienceDetailsOptions) {
  const results = useQueries({
    queries: offerIds.map((offerId) => ({
      queryKey: ExperienceDetailKeys.detail(offerId, currencyCode),
      queryFn: () => getExperienceDetail(offerId, currencyCode),
      enabled: enabled && !!offerId,
      staleTime: EXPERIENCE_DETAIL_STALE_TIME,
    })),
  })

  return {
    experienceDetails: nonNullable(results.map((result) => result.data)),
  }
}
